import { stripDispositionFromUrl } from '../../utilities/url';

export const toLabRequisitionUrl = (downloadUrl: string, apiHost: string) => {
  if (downloadUrl.startsWith('/lab-requisitions')) return downloadUrl;
  const fullUrl = downloadUrl.startsWith('http')
    ? downloadUrl
    : `${apiHost}${downloadUrl}`;
  return stripDispositionFromUrl(fullUrl);
};
